import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  MenuItem
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createStaff, updateStaff } from 'src/store/actions/StaffActions';
import { modules } from 'src/utils/utils';
import {
  createAPIAccessKeyAction,
  updateAPIAccessKeyAction
} from 'src/store/actions/AccessKeyActions';

function AccessKeyManager({ handleClose, modalData }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.Clients.clients);

  const handleSubmit = async (values) => {
    setLoading(true);
    const response = !modalData
      ? await dispatch(createAPIAccessKeyAction(values, profile))
      : await dispatch(updateAPIAccessKeyAction(modalData.id, values, profile));
    setLoading(false);
    if (response.status === 1) handleClose();
  };

  return (
    <Formik
      initialValues={{
        issuerID: `${modalData?.issuerID || ''}`,
        name: `${modalData?.name || ''}`,
        userID: `${modalData?.userID || ''}`,
        userkey: `${modalData?.userkey || ''}`
      }}
      validationSchema={Yup.object().shape({
        issuerID: Yup.string().trim().max(255),
        name: Yup.string().trim().max(255),
        userID: Yup.string().required('Required'),
        userkey: Yup.string().required('Required')
      })}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue
      }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2}>
              {profile?.super == 1 && (
                <Grid item xs="12">
                  <TextField
                    error={Boolean(touched.issuerID && errors.issuerID)}
                    helperText={touched.issuerID && errors.issuerID}
                    fullWidth
                    select
                    margin="normal"
                    name="issuerID"
                    label="Client"
                    variant="outlined"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.issuerID}
                    size="small"
                  >
                    <MenuItem value="">Please select Client</MenuItem>
                    {clients.map((item, index) => (
                      <MenuItem key={index} value={item.id}>
                        {item.fullname}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}

              {!modalData && (
                <Grid item xs="6">
                  <TextField
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label="Name"
                    margin="dense"
                    name="name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.name}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              )}

              <Grid item xs="6">
                <TextField
                  error={Boolean(touched.userID && errors.userID)}
                  fullWidth
                  helperText={touched.userID && errors.userID}
                  label="UserID"
                  margin="dense"
                  name="userID"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.userID}
                  variant="outlined"
                  size="small"
                />
              </Grid>

              <Grid item xs="6">
                <TextField
                  error={Boolean(touched.userkey && errors.userkey)}
                  fullWidth
                  helperText={touched.userkey && errors.userkey}
                  label="Userkey"
                  margin="dense"
                  name="userkey"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.userkey}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              {loading && <CircularProgress size="1.5rem" />}
              Submit
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default AccessKeyManager;
